"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _types = require("./types");
var _utils = require("../../utils");
var _default = exports["default"] = function _default(backgroundFilterName) {
  return (0, _utils.actionCreator)(_types.BROADCAST_SET_VIDEO_DEVICE_BACKGROUND_FILTER, {
    backgroundFilterName: backgroundFilterName
  });
};